﻿import api from '../api';
import { Resposta } from './Resposta';

export interface TipoPergunta {
  id: string;
  nome: string;
}

export interface Pergunta {
  descricaoComOrdem: string;
  id: string;
  pergunta: string;
  tipoPergunta: TipoPergunta;
  tipoPerguntaId: string;
  respostas: Resposta[];
  ordenacao: number | string;
  necessitaConfirmacaoDemandante: string;
  necessitaObservacaoDemandante: string;
  tituloPerguntaQuestionario: string;
  tiposMinutaConfirmacaoDemandante: string[];
  fixa?: boolean;
}

export interface PerguntaList {
  perguntas?: Pergunta[];
}

export const UpdatePergunta = (values: any) => api.put<Pergunta>('cadastroPerguntas/putPergunta', values);
export const UpdateManyPergunta = (values: any) =>
  api.put<PerguntaList>('cadastroPerguntas/UpdateManyPerguntas', values);
export const getAllPergunta = () => api.get<Pergunta[]>('cadastroPerguntas/getPergunta');
export const getAllPerguntaComResposta = () => api.get<Pergunta[]>('cadastroPerguntas/getAllPerguntaComResposta');
export const deleteResposta = (id: string) => api.delete(`cadastroPerguntas/deleteResposta/${id}`);
export const deletePergunta = (id: string) => api.delete(`cadastroPerguntas/deletePergunta/${id}`);
export const updatDescricaoPerguntaTipoPergunta = (values: Pergunta) =>
  api.put('cadastroPerguntas/updatDescricaoPerguntaTipoPergunta', values);
export const getPerguntaComRespostaByPerguntaId = (id: string) =>
  api.get<Pergunta>(`cadastroPerguntas/getPerguntaComRespostaByPerguntaId/${id}`);
